import React, { useEffect } from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import queryString from 'query-string';
import PublicFooter from '../../components/PublicFooter';
import Header from '../../components/PublicHeader';
import RequiredButton from '../../components/atoms/RequiredButton';
import ProgressMobileDialog from '../../components/molecules/ProgressMobileDialog';
import { getAccountByEmailData } from '../../libs/apis/AccountApi';
import ValidationText from '../../components/atoms/ValidationText';
import { forgotPassword } from '../../auth/Auth';

const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: '#F7F7F7',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    }
  },
  main: {
    maxWidth: 375,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 20
    // border: '1px solid #ccc'
  },
  page: {
    paddingLeft: 15,
    paddingRight: 15
  },
  paper: {
    display: 'flex',
    flexDirection: 'column'
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  titleGroup: {
    marginTop: 20,
    marginBottom: 20,
    display: 'flex',
    alignItems: 'flex-start'
  },
  pagerInDiv: {
    padding: 20
  }
});

const enhancer = compose(
  withState('email', 'setEmail', ''),
  withState('emailError', 'setEmailError', ''),
  withState('openMailSent', 'updateOpenMailSent', false),
  withState('link', 'updateLink', ''),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('titleMessage', 'setTitleMessage', ''),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  })
);

const Main = enhancer(
  ({
    classes,
    handleRedirect,
    email,
    setEmail,
    emailError,
    setEmailError,
    openMailSent,
    updateOpenMailSent,
    link,
    updateLink,
    loading,
    updateLoading,
    resultMessage,
    setResultMessage,
    titleMessage,
    setTitleMessage
  }) => {
    const url = window.location.search;
    const params = queryString.parse(url);

    useEffect(() => {
      const header = document.querySelector("link[rel~='icon']");
      if (params.key === 'naraigoto') {
        document.title = '福岡市子ども習い事応援事業';
        header.href = `${process.env.PUBLIC_URL}/images/logo_fukuoka_icon.png`;
      } else if (params.key === 'suitanaraigoto') {
        document.title = '吹田市子供の習い事費用助成事業';
      } else if (params.key === 'nishiwaki') {
        document.title = '西脇市こども未来応援事業';
      } else {
        document.title = 'ごちめし';
        header.href = `favicon.ico`;
      }
    }, []);

    const validEmail = () => {
      const value = email;
      if (value === '') {
        setEmailError('必須項目です。');
        return 1;
      }
      setEmailError('');
      setEmail(value);
      return 0;
    };

    const sendResetEmail = async () => {
      updateLoading(true);
      updateOpenMailSent(true);
      await getAccountByEmailData({ email })
        .then(response => {
          console.log('data====>', response.data.cognitoUserId);
          forgotPassword(response.data.cognitoUserId)
            .then(() => {
              updateLoading(false);
              setResultMessage(
                '入力したメールアドレス宛にパスワード再設定用のURLを送信しました。●分以内に再設定を行ってください。'
              );
              setTitleMessage('メールを送信しました。');
              updateLink(`/reset_password/${response.data.cognitoUserId}`);
            })
            .catch(error => {
              updateLoading(false);
              setEmailError('メールアドレスが正しくありません。');
              updateOpenMailSent(false);
              console.log('forgotPassword error====>', error.message);
            });
        })
        .catch(error => {
          updateLoading(false);
          setEmailError(
            'メールアドレスが間違っているか、アカウントが存在しません。 もう一度やり直してください。'
          );
          updateOpenMailSent(false);
          console.log('error====>', error.message);
        });
    };

    const progressOkAction = () => {
      updateOpenMailSent(false);
      if (link) {
        handleRedirect(link);
      }
    };

    return (
      <Container component="main" className={classes.main}>
        <CssBaseline />
        <Header />
        <div className={classes.page}>
          <div className={classes.titleGroup}>
            <Typography component="h2" variant="h5">
              パスワード再設定メール送信
            </Typography>
          </div>
          <Paper className={classes.paper} elevation={1}>
            <form className={classes.form} noValidate>
              <div className={classes.pagerInDiv}>
                <RequiredButton />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="メールアドレス"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  onChange={e => {
                    setEmail(e.target.value);
                  }}
                  onBlur={validEmail}
                />
                <ValidationText message={emailError} />
              </div>
              <Divider />
              <div className={classes.pagerInDiv}>
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={sendResetEmail}
                  disabled={!(email && !emailError)}
                >
                  送信
                </Button>
              </div>
            </form>
            <ProgressMobileDialog
              openProgress={openMailSent}
              progressOkAction={progressOkAction}
              loading={loading}
              resultMessage={resultMessage}
              title={titleMessage}
              btnText="閉じる"
              btnType="text"
            />
          </Paper>
        </div>
        <Box mt={8}>
          <PublicFooter />
        </Box>
      </Container>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
